/**
 * @ipc/admin-ui · shared/api/guards — type-guard-нарраверы для разбора unknown-ответов
 * БЕЗ as-кастов. Каждый DTO-маппер в entities-слайсах строит объект через эти хелперы
 * и не полагается на форму сырого JSON. Стиль перенесён из @acc shared/api/api-client.ts.
 */

export type PlainObject = Record<string, unknown>;

export function isPlainObject(value: unknown): value is PlainObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function asArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}

export function str(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}

export function num(value: unknown, fallback = 0): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

export function bool(value: unknown): boolean {
  return value === true;
}

export function optStr(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

export function optNum(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function optBool(value: unknown): boolean | null {
  return typeof value === 'boolean' ? value : null;
}

/** Список строк из произвольного значения (фильтрует не-строки). */
export function strList(value: unknown): string[] {
  const out: string[] = [];
  for (const item of asArray(value)) {
    if (typeof item === 'string') {
      out.push(item);
    }
  }
  return out;
}

/** Список чисел из произвольного значения (фильтрует не-числа). */
export function numList(value: unknown): number[] {
  const out: number[] = [];
  for (const item of asArray(value)) {
    if (typeof item === 'number' && Number.isFinite(item)) {
      out.push(item);
    }
  }
  return out;
}

/** Объект-словарь как есть либо null. */
export function optRecord(value: unknown): PlainObject | null {
  return isPlainObject(value) ? value : null;
}

/**
 * Применяет маппер `toX` к каждому элементу списка и отфильтровывает null.
 * Идиома для списков DTO: `mapList(raw, toPaymentRow)`.
 */
export function mapList<T>(value: unknown, toItem: (raw: unknown) => T | null): T[] {
  const out: T[] = [];
  for (const item of asArray(value)) {
    const mapped = toItem(item);
    if (mapped !== null) {
      out.push(mapped);
    }
  }
  return out;
}
